// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YjdW","colBig":"styles_colBig__2dMfo","colSmall":"styles_colSmall__2TiFc"};